import React, {PureComponent} from "react";
import {Modal} from "antd";

/**
 * uploadIcon组件
 */
class UploadIcon extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        const {
            formInfoData,
            isAuditing,
            value
        } = this.props.fieldProps;
        const positionCreator = `${formInfoData.belongUserName || "暂无"}${formInfoData.belongDeptName ? `（${formInfoData.belongDeptName}）` : ''}`;
        // （审核中 || 审核不通过）&& 审核意见存在   =》  展示查看审核意见
        let showAuditOpinion = (isAuditing || formInfoData?.statusName?.indexOf("审核不通过") > -1) && formInfoData?.remarks;
        return (
            <>
                <div style={{display: "flex", height: 60}}>
                    <div style={{marginRight: 10}}>
                        <img src={value} alt="avatar" style={{
                            width: '56px',
                            height: '56px',
                            lineHeight: "52px",
                            borderRadius: "50%",
                            objectFit: 'cover'
                        }}/>
                    </div>
                    <div style={{lineHeight: showAuditOpinion ? "20px" :"28px"}}>
                        <div style={{display: "flex"}}>
                            <div style={{
                                fontWeight: 500,
                                display: "inline-block",
                                width: 70
                            }}>账号状态：
                            </div>
                            <div title={formInfoData.statusName} style={{
                                maxWidth: 160,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}>
                                {formInfoData.statusName}
                            </div>
                            <div>
                                {isAuditing ? `（${formInfoData.processName}）` : ''}
                            </div>
                        </div>
                        <div style={{display: "flex"}}>
                            <div style={{
                                fontWeight: 500,
                                display: "inline-block",
                                width: 85
                            }}>账号所属人：
                            </div>
                            <div title={positionCreator} style={{
                                maxWidth: 180,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}>
                                {positionCreator}
                            </div>
                        </div>
                        {showAuditOpinion && <div>
                                    <span style={{color: "#0050B3", cursor: "pointer"}} onClick={() => {
                                        Modal.info({
                                            title: formInfoData.remarks,
                                            okText: "关闭",
                                            okType: "default"
                                        });
                                    }}>查看审核意见</span>
                        </div>}
                    </div>
                </div>
                <style>{`
                                            .rmt-input-content-layout .ant-upload.ant-upload-select-picture-card{width:56px;height:56px;line-height: 52px;}
                                            .rmt-input-content-layout .ant-upload.ant-upload-select-picture-card > .ant-upload{padding: 0;}
                                            .rmt-input-content-layout .ant-upload.ant-upload-select-picture-card #logo{width:56px;height:56px;line-height: 52px;border-radius: 50%;
                                                            background: rgba(0,80,179,0.0800);}
                                            .avatar-uploader .anticon svg{width: 30px;height: 30px;margin-top: 13px}; color: #0050B3;}
                            `}
                </style>
            </>
        )
    }
}

export default UploadIcon;